// @generated by protoc-gen-es v2.12.1 with parameter "target=ts,json_types=true"
// @generated from file integrations/v1/sink.proto (package integrations.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import type { Timestamp, TimestampJson, Value, ValueJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_common_v1_events } from "../../common/v1/events_pb";
import type { ConnectorType, ConnectorTypeJson } from "./connector_pb";
import { file_integrations_v1_connector } from "./connector_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file integrations/v1/sink.proto.
 */
export const file_integrations_v1_sink: GenFile =
	/*@__PURE__*/
	fileDesc(
		"ChppbnRlZ3JhdGlvbnMvdjEvc2luay5wcm90bxIPaW50ZWdyYXRpb25zLnYxIpIBCgdDb250YWN0EjwKCnByb3BlcnRpZXMYASADKAsyKC5pbnRlZ3JhdGlvbnMudjEuQ29udGFjdC5Qcm9wZXJ0aWVzRW50cnkaSQoPUHJvcGVydGllc0VudHJ5EgsKA2tleRgBIAEoCRIlCgV2YWx1ZRgCIAEoCzIWLmdvb2dsZS5wcm90b2J1Zi5WYWx1ZToCOAEigwEKBk9yaWdpbhIVCg1jb25uZWN0aW9uX2lkGAEgASgJEhgKEGludGVncmF0aW9uX25hbWUYAiABKAkSEAoIZXZlbnRfaWQYAyABKAkSNgoOY29ubmVjdG9yX3R5cGUYBCABKA4yHi5pbnRlZ3JhdGlvbnMudjEuQ29ubmVjdG9yVHlwZSLZAQoPQ29udGFjdFJlY2VpdmVkEg4KBm9yZ19pZBgBIAEoCRIUCgx3b3Jrc3BhY2VfaWQYAiABKAkSFQoNY29ubmVjdGlvbl9pZBgDIAEoCRIpCgdjb250YWN0GAQgASgLMhguaW50ZWdyYXRpb25zLnYxLkNvbnRhY3QSJwoGb3JpZ2luGAYgASgLMhcuaW50ZWdyYXRpb25zLnYxLk9yaWdpbhIvCgtyZWNlaXZlZF9hdBgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXA6BIi1GAEitAEKFlB1Ymxpc2hDb250YWN0c1JlcXVlc3QSFAoMd29ya3NwYWNlX2lkGAEgASgJEhAKCGV2ZW50X2lkGAIgASgJEhUKDWNvbm5lY3Rpb25faWQYAyABKAkSKgoIY29udGFjdHMYBCADKAsyGC5pbnRlZ3JhdGlvbnMudjEuQ29udGFjdBIvCgtyZWNlaXZlZF9hdBgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAiGQoXUHVibGlzaENvbnRhY3RzUmVzcG9uc2UiQQoSR2V0U2lua0hlYWRSZXF1ZXN0EhQKDHdvcmtzcGFjZV9pZBgBIAEoCRIVCg1jb25uZWN0aW9uX2lkGAIgASgJImcKE0dldFNpbmtIZWFkUmVzcG9uc2USNQoRbGFzdF9wdWJsaXNoZWRfYXQYASABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhkKEXJlY29yZHNfcHVibGlzaGVkGAIgASgFMt0BCgtTaW5rU2VydmljZRJsCg9QdWJsaXNoQ29udGFjdHMSJy5pbnRlZ3JhdGlvbnMudjEuUHVibGlzaENvbnRhY3RzUmVxdWVzdBooLmludGVncmF0aW9ucy52MS5QdWJsaXNoQ29udGFjdHNSZXNwb25zZSIGwu0aAggCEmAKC0dldFNpbmtIZWFkEiMuaW50ZWdyYXRpb25zLnYxLkdldFNpbmtIZWFkUmVxdWVzdBokLmludGVncmF0aW9ucy52MS5HZXRTaW5rSGVhZFJlc3BvbnNlIgbC7RoCCAJiBnByb3RvMw",
		[file_common_v1_annotations, file_google_api_annotations, file_google_protobuf_struct, file_common_v1_events, file_google_protobuf_timestamp, file_integrations_v1_connector],
	);

/**
 * @generated from message integrations.v1.Contact
 */
export type Contact = Message<"integrations.v1.Contact"> & {
	/**
	 * @generated from field: map<string, google.protobuf.Value> properties = 1;
	 */
	properties: { [key: string]: Value };
};

/**
 * @generated from message integrations.v1.Contact
 */
export type ContactJson = {
	/**
	 * @generated from field: map<string, google.protobuf.Value> properties = 1;
	 */
	properties?: { [key: string]: ValueJson };
};

/**
 * Describes the message integrations.v1.Contact.
 * Use `create(ContactSchema)` to create a new message.
 */
export const ContactSchema: GenMessage<Contact, { jsonType: ContactJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_sink, 0);

/**
 * Origin represents the origin of a contact event, including the connection ID and integration name.
 *
 * @generated from message integrations.v1.Origin
 */
export type Origin = Message<"integrations.v1.Origin"> & {
	/**
	 * the unique id of the integration app installation. e.g. installing hubspot twice in the
	 * same workspace would result in two different connection ids. this is important as it is
	 * the most granular level at which we can identify a connection, allowing us to navigate
	 * to specific connection details (e.g. integration name, installer, etc.) if needed.
	 *
	 * @generated from field: string connection_id = 1;
	 */
	connectionId: string;

	/**
	 * the name of the integration that received the contact
	 *
	 * @generated from field: string integration_name = 2;
	 */
	integrationName: string;

	/**
	 * the unique id of the event received from the integration
	 *
	 * @generated from field: string event_id = 3;
	 */
	eventId: string;

	/**
	 * the type of the connector that received the contact
	 *
	 * @generated from field: integrations.v1.ConnectorType connector_type = 4;
	 */
	connectorType: ConnectorType;
};

/**
 * Origin represents the origin of a contact event, including the connection ID and integration name.
 *
 * @generated from message integrations.v1.Origin
 */
export type OriginJson = {
	/**
	 * the unique id of the integration app installation. e.g. installing hubspot twice in the
	 * same workspace would result in two different connection ids. this is important as it is
	 * the most granular level at which we can identify a connection, allowing us to navigate
	 * to specific connection details (e.g. integration name, installer, etc.) if needed.
	 *
	 * @generated from field: string connection_id = 1;
	 */
	connectionId?: string;

	/**
	 * the name of the integration that received the contact
	 *
	 * @generated from field: string integration_name = 2;
	 */
	integrationName?: string;

	/**
	 * the unique id of the event received from the integration
	 *
	 * @generated from field: string event_id = 3;
	 */
	eventId?: string;

	/**
	 * the type of the connector that received the contact
	 *
	 * @generated from field: integrations.v1.ConnectorType connector_type = 4;
	 */
	connectorType?: ConnectorTypeJson;
};

/**
 * Describes the message integrations.v1.Origin.
 * Use `create(OriginSchema)` to create a new message.
 */
export const OriginSchema: GenMessage<Origin, { jsonType: OriginJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_sink, 1);

/**
 * ContactReceived represents a contact received on behalf of a workspace by an integration connection.
 *
 * @generated from message integrations.v1.ContactReceived
 */
export type ContactReceived = Message<"integrations.v1.ContactReceived"> & {
	/**
	 * the org id where the connection is installed and contact received
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * the workspace id where the connection is installed and contact received
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * the unique id of the integration app installation. e.g. installing hubspot twice in the
	 * same workspace would result in two different connection ids. this is important as it is
	 * the most granular level at which we can identify a connection, allowing us to navigate
	 * to specific connection details (e.g. integration name, installer, etc.) if needed.
	 *
	 * @generated from field: string connection_id = 3;
	 */
	connectionId: string;

	/**
	 * the contact data received from the integration
	 *
	 * @generated from field: integrations.v1.Contact contact = 4;
	 */
	contact?: Contact | undefined;

	/**
	 * the origin of the contact event, including the connection ID and integration name.
	 *
	 * @generated from field: integrations.v1.Origin origin = 6;
	 */
	origin?: Origin | undefined;

	/**
	 * the timestamp when the contact was received from the integration source.
	 *
	 * @generated from field: google.protobuf.Timestamp received_at = 5;
	 */
	receivedAt?: Timestamp | undefined;
};

/**
 * ContactReceived represents a contact received on behalf of a workspace by an integration connection.
 *
 * @generated from message integrations.v1.ContactReceived
 */
export type ContactReceivedJson = {
	/**
	 * the org id where the connection is installed and contact received
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * the workspace id where the connection is installed and contact received
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * the unique id of the integration app installation. e.g. installing hubspot twice in the
	 * same workspace would result in two different connection ids. this is important as it is
	 * the most granular level at which we can identify a connection, allowing us to navigate
	 * to specific connection details (e.g. integration name, installer, etc.) if needed.
	 *
	 * @generated from field: string connection_id = 3;
	 */
	connectionId?: string;

	/**
	 * the contact data received from the integration
	 *
	 * @generated from field: integrations.v1.Contact contact = 4;
	 */
	contact?: ContactJson;

	/**
	 * the origin of the contact event, including the connection ID and integration name.
	 *
	 * @generated from field: integrations.v1.Origin origin = 6;
	 */
	origin?: OriginJson;

	/**
	 * the timestamp when the contact was received from the integration source.
	 *
	 * @generated from field: google.protobuf.Timestamp received_at = 5;
	 */
	receivedAt?: TimestampJson;
};

/**
 * Describes the message integrations.v1.ContactReceived.
 * Use `create(ContactReceivedSchema)` to create a new message.
 */
export const ContactReceivedSchema: GenMessage<ContactReceived, { jsonType: ContactReceivedJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_sink, 2);

/**
 * PublishContactsRequest is the request message for the PublishContacts RPC.
 *
 * @generated from message integrations.v1.PublishContactsRequest
 */
export type PublishContactsRequest = Message<"integrations.v1.PublishContactsRequest"> & {
	/**
	 * the workspace id where the contacts are being published.
	 *
	 * @generated from field: string workspace_id = 1;
	 */
	workspaceId: string;

	/**
	 * the id of the event that triggered the contact publishing. this id can be
	 * duplicated across requests for cases like batched writes.
	 *
	 * @generated from field: string event_id = 2;
	 */
	eventId: string;

	/**
	 * the connection id (see ContactReceived.connection_id for more details)
	 *
	 * @generated from field: string connection_id = 3;
	 */
	connectionId: string;

	/**
	 * the contacts to be published to the sink.
	 *
	 * @generated from field: repeated integrations.v1.Contact contacts = 4;
	 */
	contacts: Contact[];

	/**
	 * the timestamp when the contact was received from the integration source.
	 *
	 * @generated from field: google.protobuf.Timestamp received_at = 5;
	 */
	receivedAt?: Timestamp | undefined;
};

/**
 * PublishContactsRequest is the request message for the PublishContacts RPC.
 *
 * @generated from message integrations.v1.PublishContactsRequest
 */
export type PublishContactsRequestJson = {
	/**
	 * the workspace id where the contacts are being published.
	 *
	 * @generated from field: string workspace_id = 1;
	 */
	workspaceId?: string;

	/**
	 * the id of the event that triggered the contact publishing. this id can be
	 * duplicated across requests for cases like batched writes.
	 *
	 * @generated from field: string event_id = 2;
	 */
	eventId?: string;

	/**
	 * the connection id (see ContactReceived.connection_id for more details)
	 *
	 * @generated from field: string connection_id = 3;
	 */
	connectionId?: string;

	/**
	 * the contacts to be published to the sink.
	 *
	 * @generated from field: repeated integrations.v1.Contact contacts = 4;
	 */
	contacts?: ContactJson[];

	/**
	 * the timestamp when the contact was received from the integration source.
	 *
	 * @generated from field: google.protobuf.Timestamp received_at = 5;
	 */
	receivedAt?: TimestampJson;
};

/**
 * Describes the message integrations.v1.PublishContactsRequest.
 * Use `create(PublishContactsRequestSchema)` to create a new message.
 */
export const PublishContactsRequestSchema: GenMessage<PublishContactsRequest, { jsonType: PublishContactsRequestJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_sink, 3);

/**
 * PublishContactsResponse is the response message for the PublishContacts RPC.
 *
 * @generated from message integrations.v1.PublishContactsResponse
 */
export type PublishContactsResponse = Message<"integrations.v1.PublishContactsResponse"> & {};

/**
 * PublishContactsResponse is the response message for the PublishContacts RPC.
 *
 * @generated from message integrations.v1.PublishContactsResponse
 */
export type PublishContactsResponseJson = {};

/**
 * Describes the message integrations.v1.PublishContactsResponse.
 * Use `create(PublishContactsResponseSchema)` to create a new message.
 */
export const PublishContactsResponseSchema: GenMessage<PublishContactsResponse, { jsonType: PublishContactsResponseJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_sink, 4);

/**
 * GetSinkHeadRequest is the request message for the GetSinkHead RPC.
 *
 * @generated from message integrations.v1.GetSinkHeadRequest
 */
export type GetSinkHeadRequest = Message<"integrations.v1.GetSinkHeadRequest"> & {
	/**
	 * @generated from field: string workspace_id = 1;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string connection_id = 2;
	 */
	connectionId: string;
};

/**
 * GetSinkHeadRequest is the request message for the GetSinkHead RPC.
 *
 * @generated from message integrations.v1.GetSinkHeadRequest
 */
export type GetSinkHeadRequestJson = {
	/**
	 * @generated from field: string workspace_id = 1;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string connection_id = 2;
	 */
	connectionId?: string;
};

/**
 * Describes the message integrations.v1.GetSinkHeadRequest.
 * Use `create(GetSinkHeadRequestSchema)` to create a new message.
 */
export const GetSinkHeadRequestSchema: GenMessage<GetSinkHeadRequest, { jsonType: GetSinkHeadRequestJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_sink, 5);

/**
 * GetSinkHeadResponse is the response message for the GetSinkHead RPC.
 * It describes the head of the sink, including the last published timestamp and the number of records published.
 *
 * @generated from message integrations.v1.GetSinkHeadResponse
 */
export type GetSinkHeadResponse = Message<"integrations.v1.GetSinkHeadResponse"> & {
	/**
	 * @generated from field: google.protobuf.Timestamp last_published_at = 1;
	 */
	lastPublishedAt?: Timestamp | undefined;

	/**
	 * @generated from field: int32 records_published = 2;
	 */
	recordsPublished: number;
};

/**
 * GetSinkHeadResponse is the response message for the GetSinkHead RPC.
 * It describes the head of the sink, including the last published timestamp and the number of records published.
 *
 * @generated from message integrations.v1.GetSinkHeadResponse
 */
export type GetSinkHeadResponseJson = {
	/**
	 * @generated from field: google.protobuf.Timestamp last_published_at = 1;
	 */
	lastPublishedAt?: TimestampJson;

	/**
	 * @generated from field: int32 records_published = 2;
	 */
	recordsPublished?: number;
};

/**
 * Describes the message integrations.v1.GetSinkHeadResponse.
 * Use `create(GetSinkHeadResponseSchema)` to create a new message.
 */
export const GetSinkHeadResponseSchema: GenMessage<GetSinkHeadResponse, { jsonType: GetSinkHeadResponseJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_sink, 6);

/**
 * SinkService is responsible for receiving and publishing integration payloads to their destination sink.
 *
 * @generated from service integrations.v1.SinkService
 */
export const SinkService: GenService<{
	/**
	 * @generated from rpc integrations.v1.SinkService.PublishContacts
	 */
	publishContacts: {
		methodKind: "unary";
		input: typeof PublishContactsRequestSchema;
		output: typeof PublishContactsResponseSchema;
	};
	/**
	 * @generated from rpc integrations.v1.SinkService.GetSinkHead
	 */
	getSinkHead: {
		methodKind: "unary";
		input: typeof GetSinkHeadRequestSchema;
		output: typeof GetSinkHeadResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_integrations_v1_sink, 0);
